import { Directive, ViewContainerRef, inject } from "@angular/core";

@Directive({ selector: "[transformerToolbarHost]" })
export class ToolbarDirective {
  viewContainerRef = inject(ViewContainerRef);
}
